module.exports = __webpack_public_path__ + "static/img/home-item2.fe7358e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item2.png
// module id = BWtX
// module chunks = 21